(function () {
  function bind(clock) {
    if (clock.dataset.lprBound) return;
    clock.dataset.lprBound = '1';
    var dur = parseInt(clock.getAttribute('data-duration'), 10) || 345600;
    var KEY = 'lpr_countdown_end';
    function ends() {
      var now = Date.now();
      var end = parseInt(localStorage.getItem(KEY) || '0', 10);
      if (!end || end <= now) {
        end = now + dur * 1000;
        try {
          localStorage.setItem(KEY, String(end));
        } catch (e) {}
      }
      return end;
    }
    var target = ends();
    var d = clock.querySelector('[data-d]');
    var h = clock.querySelector('[data-h]');
    var m = clock.querySelector('[data-m]');
    var s = clock.querySelector('[data-s]');
    function pad(n) {
      return (n < 10 ? '0' : '') + n;
    }
    function tick() {
      var diff = Math.floor((target - Date.now()) / 1000);
      if (diff <= 0) {
        try {
          localStorage.removeItem(KEY);
        } catch (e) {}
        target = ends();
        diff = Math.floor((target - Date.now()) / 1000);
      }
      var dd = Math.floor(diff / 86400);
      var hh = Math.floor((diff % 86400) / 3600);
      var mm = Math.floor((diff % 3600) / 60);
      var ss = diff % 60;
      if (d) d.textContent = pad(dd);
      if (h) h.textContent = pad(hh);
      if (m) m.textContent = pad(mm);
      if (s) s.textContent = pad(ss);
    }
    tick();
    setInterval(tick, 1000);
  }

  function scan(root) {
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll('.lpr-cart-countdown__clock').forEach(bind);
  }

  function start() {
    scan(document);
    new MutationObserver(function (mutations) {
      mutations.forEach(function (mut) {
        mut.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.matches && node.matches('.lpr-cart-countdown__clock')) bind(node);
          scan(node);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.body) {
    start();
  } else {
    document.addEventListener('DOMContentLoaded', start);
  }
})();
